// extracted by mini-css-extract-plugin
export default {"table_wrapper":"PatientsOperationsTable_table_wrapper__l9LLN"};